export default {
    baseUrl: "/manager/data",
};
